<template>
    <sa-page-layout :btnNewVisible="btnNewVisible" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource" :linkedit="linkedit" :showModalLoading="showModalLoading" :btnConfigurazioniVisible="btnConfigurazioniVisible" :linkConfigurazioni="linkConfigurazioni">
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Setting</label>
                        <b-form-select v-model="filtroConfigurazioneSettingLivelli.idSetting" :options="settingOptions"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Descrizione:</label>
                        <b-form-input v-model="filtroConfigurazioneSettingLivelli.descrizione" type="search" id="descrizione" placeholder="Descrizione"></b-form-input>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-body">
            <rsa-configurazione-setting-livelli-list-component ref="RsaConfigurazioneSettingLivelliListComponent" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData" @updateFilter="onUpdateFilter" />
        </template>
    </sa-page-layout>
</template>
<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaConfigurazioneSettingLivelliListComponent from "../components/RsaConfigurazioneSettingLivelliListComponent.vue";
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    mixins: [UtilityMixin],
    components: { SaPageLayout, RsaConfigurazioneSettingLivelliListComponent },
    data() {
        return {
            btnConfigurazioniVisible: true,
            filtro: {},
            btnNewVisible: true,
            pathResource: "",
            pathResourceSetting: "/rsasettings",
            linkConfigurazioni: "/configurazioni",
            showModalLoading: false,
            listKey: 0,
            linkedit: "/settingslivelli",
            filtroConfigurazioneSettingLivelli: { descrizione: "", idSetting: null },
            settingOptions: [{ value: null, text: "Seleziona un setting" }],
        };
    },
    mounted() {
        let me = this;
        let sessionStorage = window.sessionStorage;
        if (sessionStorage["filtroConfigurazioneSettingLivelli"]) {
            me.filtroConfigurazioneSettingLivelli = JSON.parse(sessionStorage["filtroConfigurazioneSettingLivelli"]);
        }

        me.loadSettingOptions();
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.$refs.RsaConfigurazioneSettingLivelliListComponent.loadData();
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onReset() {
            let me = this;
            me.filtroConfigurazioneSettingLivelli = { descrizione: "", idSetting: null };
            me.showModalLoading = true;
            me.onSubmit();
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroConfigurazioneSettingLivelli"] = JSON.stringify(me.filtroConfigurazioneSettingLivelli);
            me.loadData();
        },
        onError(errorData) {
            console.error("RsaConfigurazioneSettingLivelliListPage - onError", errorData);
        },
        loadSettingOptions() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSetting, {}, me.loadSettingOptionsSuccess, me.loadSettingOptionsError);
        },
        loadSettingOptionsSuccess(response) {
            let me = this;
            response.data.data.list.forEach((item) => {
                me.settingOptions.push({ value: item.id, text: item.setting });
            });
        },
        loadSettingOptionsError(error) {
            console.error("RsaConfigurazioneSettingLivelliListPage - loadSettingOptionsError", error);
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onUpdateFilter(filtro) {
            let me = this;
            me.filtroConfigurazioneSettingLivelli = filtro;
        },
    },
};
</script>

<style></style>
